"use client";

import NextLink from "components/parts/NextLink";
import type { TradeFormProps } from "types/prices";
import { URLS } from "constants/common";
import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import { Button } from "app/_components/components/Button";

const MobileFooter = ({ tradeForm }: TradeFormProps) => {
  const t = useTranslations(FILES.PRICES);
  if (!tradeForm?.isTrading && !tradeForm?.isCustody) {
    return null;
  }

  const { coinName, isTrading } = tradeForm;
  const ctaLabelKey = isTrading ? "buyButton" : "storeButton";

  return (
    <div className="fixed bottom-0 left-0 z-[99] flex w-full flex-col p-4 shadow-[0px_0px_40px_rgba(26,26,26,0.1)] md:hidden">
      <NextLink
        href={URLS.REGISTER}
        id="register-buy-button"
        className="m-0 w-full"
      >
        <Button size="lg" variant="primary" className="w-full">
          {t(ctaLabelKey, { coinName })}{" "}
        </Button>
      </NextLink>
    </div>
  );
};

export default MobileFooter;
